import apiClient from '@/api/common/axios';
import { API_ENDPOINTS } from '@/constants';
import type { LoginResponse, UserProfile } from '@/types/auth';

export const authApi = {
  // Username/password login disabled - Microsoft SSO only
  // login: (data: LoginRequest) =>
  //   apiClient.post<LoginResponse>(API_ENDPOINTS.AUTH.LOGIN, data),

  ssoLogin: (msalToken: string, email: string, idToken?: string) =>
    apiClient.post<LoginResponse>(API_ENDPOINTS.AUTH.SSO_LOGIN, { msalToken, email, idToken }),

  me: () =>
    apiClient.get<UserProfile>(API_ENDPOINTS.AUTH.ME),

  setActiveOrganization: (organizationId: string) =>
    apiClient.put<LoginResponse>(API_ENDPOINTS.AUTH.ACTIVE_ORGANIZATION, { organizationId }),

  refresh: (refreshToken: string) =>
    apiClient.post<LoginResponse>(API_ENDPOINTS.AUTH.REFRESH, JSON.stringify(refreshToken)),

  // forgotPassword: (email: string, subdomain: string) =>
  //   apiClient.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, { email, subdomain }),

  // resetPassword: (token: string, newPassword: string) =>
  //   apiClient.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, { token, newPassword }),

  onboarding: (token: string, data: object) =>
    apiClient.post(`${API_ENDPOINTS.AUTH.ONBOARDING}/${token}`, data),
};
